import type { StateTree } from '@makemydeal/dr-dash-types';
import type { RealState } from '@makemydeal/shared-scoped-store';
import { scopedStateSelectors } from '@makemydeal/shared-scoped-store';
import * as multiScenarioSelectors from './multiScenarioSelectors';
import * as dealTemplateSelectors from './dealTemplateSelectors';

export const getAsyncScenarioExpectedIds = (state: StateTree): string[] => {
    if (dealTemplateSelectors.getIsDealTemplateApplied(state)) {
        const realState = state as unknown as RealState;
        const primaryScopeId = scopedStateSelectors.getPrimaryScopeId(realState);
        return scopedStateSelectors.getScopesOrder(realState).filter((id) => id !== primaryScopeId);
    }

    const scenarios = multiScenarioSelectors.getActiveComparison(state)?.scenarios ?? [];
    return scenarios.filter((s) => !s.isPrimary).map((s) => s.id);
};

export const getAsyncScenarioReceivedIds = (state: StateTree): string[] => {
    const expected = getAsyncScenarioExpectedIds(state);
    if (expected.length === 0) return [];
    const initializedSet = new Set(scopedStateSelectors.getInitializedScopesOrder(state as unknown as RealState));
    return expected.filter((id) => initializedSet.has(id));
};

export const getAsyncScenarioMissingIds = (state: StateTree): string[] => {
    const expected = getAsyncScenarioExpectedIds(state);
    const received = new Set(getAsyncScenarioReceivedIds(state));
    return expected.filter((id) => !received.has(id));
};

export const hasAsyncScenarioLoadCompleted = (state: StateTree): boolean => {
    const expected = getAsyncScenarioExpectedIds(state);
    if (expected.length === 0) return false;
    return getAsyncScenarioMissingIds(state).length === 0;
};
